import React, {Fragment, useContext, useEffect, useState} from "react";
import {useQueryClient} from "react-query";
import moment from "moment";
import {Button, FormControl, FormGroup, Grid, Icon, Tooltip, useTheme} from "@material-ui/core";

import SystemContext from "../../../SystemContext";
import {
  FormDialog,
  LabelledPaper,
} from "../../../controls";
import {useAirports} from "../../../services/airports";
import { getBookingFlightOptions } from "../BookingHelperFunctions";

const paperProps = {
  style: {
    backgroundColor: "#f8f8f8",
    boxShadow: 'none',
  }
}

const defaultLabelledPaperProps = {
  checkChildren: true,
  style: {display: "block", border: "solid 1px #b9b9b9" },
  labelStyle: {background: "#f0f0f0"},
  collapsible: false,
}

const AirportData = (props) => {
  const queryClient = useQueryClient();
  const airport = useAirports({queryClient, extraKeys:[props.airportCode], useCache: true});

  return (<div style={props.style}>{airport.data?airport.data[0][props.field]:props.airportCode}</div>)
}

const FlightBlock = (props) => {
  const color = "#505050";
  const withinCurfew = props.withinCurfew;
  const diverted = props.diverted;
  const {noteText, noteData} = props.diversionDetails||{};
  const {destinationAirportCode, divertedToAirport} = noteData||{};
  let colorProps = withinCurfew?{backgroundColor: "rgba(255,0,0,1)"}:diverted?{backgroundColor: "rgba(118,71,152,1)"}:{}
  return (
    <div style={{width: 120, display: "inline-block", border: `2px solid ${color}`, textAlign: "center", ...colorProps}}>
      <div style={{fontSize: 18, fontWeight: "bold", padding: 2, color: `${color}`}}>{diverted?<span style={{textDecoration:"line-through", paddingRight: 5}}>{destinationAirportCode}</span>:''}{props.airportCode}</div>
      <div style={{fontSize: 16, fontWeight: "bold", padding: 2, color: `${color}`}}><AirportData airportCode={props.airportCode} field='icaoCode'/></div>
      <div style={{fontSize: 14, fontWeight: "bold", padding: 2, color: `${color}`}}>{moment.utc(props.flightTime).format('DD MMM HH:mm')}</div>
    </div>
  )
}

const FullRoute = (props) => {
  console.log(props.airport)
  return (
    props.fullRoute
      ?
        <div style={{ textAlign: "center", display: "inline-flex" }}>
          {props.fullRoute.map(leg => {
            return(
              <div style={{ padding: 5, paddingTop: 0, textAlign: "center", display: "flex"}}>
                { leg.airport !== `${props.airport}` ? leg.transportType === "TRUCK" ? <div style={{position: "relative", left: "-5px", top: "3px"}}><Icon style={{fontSize: 10}}>local_shipping</Icon></div> : <div style={{position: "relative", left: "-7px", transform: "rotate(90deg)"}}><Icon style={{fontSize: 10}}>flight</Icon></div> : <></> }
                <div style={{fontSize: 12, padding: 4, paddingTop: 2, width: "100%", color: "#909090"}}>{leg.airport}</div>
              </div>
            );})
          }
        </div>
      :
        <></>
  );
}


const FlightOptions = (_props) => {
  const props = {
    canEdit: false,
    ..._props,
  }
  const classes = props.classes;
  const theme = useTheme();

  const [dialogStates, setDialogStates] = useState({...props.dialogStates});
  const [record, setRecord] = useState(props.record);
  const [flightOptions, setFlightOptions] = useState(null);
  const [alert, setAlert] = useState({
    open: false,
    severity: "error",
    message: "",
  });

  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;

  useEffect(() => {
    const open = (params) => {
      const record = {...params};
      setRecord(record);
      setDialogStates({showDialog: true});

      // setFlightOptions ([
      //   {
      //     "companyUuid": "f1cf447e-b7bd-47b8-b2cd-3c6a001b50e2",
      //     "companyName": "Senator International Spedition GmbH",
      //     "originAirportCode": "HHN",
      //     "destinationAirportCode": "JNB",
      //     "flightDate": "2022-09-21",
      //     "route": "HHN-JNB",
      //     "airlineCode": "CC",
      //     "flightNo": "783",
      //     "scheduledDepartureTimeUTC": "2022-09-21T14:00:00.000Z",
      //     "scheduledArrivalTimeUTC": "2022-09-22T00:30:00.000Z",
      //     "legs1": [{tripLegUuid: "04a0d140-5300-41b2-80b4-b28438233ff6", destination: "JNB"}],
      //     "legs2": null,
      //     "trip1": "49f17c19-7d38-43cc-a4eb-aba60cf890e6",
      //     "trip2": null,
      //     "legCount": 1,
      //     "tripCount": 1,
      //     "transitAirport": null,
      //     "transitAirlineCode": null,
      //     "transitFlightNo": null,
      //     "transitScheduledDepartureTimeUTC": null
      //   },
      //   {
      //     "companyUuid": "f1cf447e-b7bd-47b8-b2cd-3c6a001b50e2",
      //     "companyName": "Senator International Spedition GmbH",
      //     "originAirportCode": "HHN",
      //     "destinationAirportCode": "JNB",
      //     "flightDate": "2022-09-23",
      //     "route": "HHN-JNB",
      //     "airlineCode": "CC",
      //     "flightNo": "785",
      //     "scheduledDepartureTimeUTC": "2022-09-23T22:00:00.000Z",
      //     "scheduledArrivalTimeUTC": "2022-09-24T08:30:00.000Z",
      //     "legs1": [{tripLegUuid: "0061ac78-8f8d-4880-816c-f0a58160aebc", destination: "JNB"}],
      //     "legs2": null,
      //     "trip1": "e7ab5ced-6710-422a-bd49-a136ceb2f9e5",
      //     "trip2": null,
      //     "legCount": 1,
      //     "tripCount": 1,
      //     "transitAirport": null,
      //     "transitAirlineCode": null,
      //     "transitFlightNo": null,
      //     "transitScheduledDepartureTimeUTC": null
      //   },
      //   {
      //     "companyUuid": "f1cf447e-b7bd-47b8-b2cd-3c6a001b50e2",
      //     "companyName": "Senator International Spedition GmbH",
      //     "originAirportCode": "HHN",
      //     "destinationAirportCode": "JNB",
      //     "flightDate": "2022-09-30",
      //     "route": "HHN-JNB",
      //     "airlineCode": "CC",
      //     "flightNo": "785",
      //     "scheduledDepartureTimeUTC": "2022-09-30T22:00:00.000Z",
      //     "scheduledArrivalTimeUTC": "2022-10-01T08:30:00.000Z",
      //     "legs1": [{tripLegUuid: "ae732e09-ff5b-4361-a4d0-4107661e2016", destination: "JNB"}],
      //     "legs2": null,
      //     "trip1": "fefaf7ce-6d83-40d8-9c8e-092c774fbc41",
      //     "trip2": null,
      //     "legCount": 1,
      //     "tripCount": 1,
      //     "transitAirport": null,
      //     "transitAirlineCode": null,
      //     "transitFlightNo": null,
      //     "transitScheduledDepartureTimeUTC": null
      //   },
      //   {
      //     "companyUuid": "f1cf447e-b7bd-47b8-b2cd-3c6a001b50e2",
      //     "companyName": "Senator International Spedition GmbH",
      //     "originAirportCode": "HHN",
      //     "destinationAirportCode": "JNB",
      //     "flightDate": "2022-09-30",
      //     "route": "HHN-JNB",
      //     "airlineCode": "CC",
      //     "flightNo": "785",
      //     "scheduledDepartureTimeUTC": "2022-09-30T22:00:00.000Z",
      //     "scheduledArrivalTimeUTC": "2022-10-01T08:30:00.000Z",
      //     "legs1": [{tripLegUuid: "ae732e09-ff5b-4361-a4d0-4107661e2016", destination: "JNB"}],
      //     "legs2": null,
      //     "trip1": "fefaf7ce-6d83-40d8-9c8e-092c774fbc41",
      //     "trip2": null,
      //     "legCount": 1,
      //     "tripCount": 1,
      //     "transitAirport": null,
      //     "transitAirlineCode": null,
      //     "transitFlightNo": null,
      //     "transitScheduledDepartureTimeUTC": null
      //   },
      //   {
      //     "companyUuid": "f1cf447e-b7bd-47b8-b2cd-3c6a001b50e2",
      //     "companyName": "Senator International Spedition GmbH",
      //     "originAirportCode": "SIN",
      //     "destinationAirportCode": "RFD",
      //     "flightDate": "2022-09-16",
      //     "route": "SIN-HHN-RFD",
      //     "airlineCode": "CC",
      //     "flightNo": "796",
      //     "scheduledDepartureTimeUTC": "2022-09-16 11:45:00.0Z",
      //     "scheduledArrivalTimeUTC": "2022-09-25 04:15:00.0Z",
      //     "legs1": [{"tripLegUuid": "b33b281d-02c7-408c-b092-89a2e1e44013", "destination": "DWC"}, {"tripLegUuid": "ae4d3ae7-de1f-42c6-b87f-c3397a9d7626", "destination": "HHN"}],
      //     "legs2": [{"tripLegUuid": "62fa3a73-e358-4cbf-9450-989ef6d633a6", "destination": "RFD"}],
      //     "trip1": "fefaf7ce-6d83-40d8-9c8e-092c774fbc41",
      //     "trip2": "731fb851-d846-4917-ae53-f85d5c3bfcdb",
      //     "legCount": 3,
      //     "tripCount": 2,
      //     "transitAirport": "HHN",
      //     "transitAirlineCode": "5Y",
      //     "transitFlightNo": "4766",
      //     "transitScheduledDepartureTimeUTC": "2022-09-24 19:00:00.0Z"
      //     "isFreesale1"
      //     "isFreesale2"
      //   }
      // ]);

      const options = getBookingFlightOptions(SystemData, record.flightDate, record.charterOrigin, record.destination, record.gsaCompanyUuid)
        .then( (flightOptions) => {
          if (flightOptions && Array.isArray(flightOptions)) {
            flightOptions.forEach(option => {
              option.legs1 = JSON.parse(option.legs1);
              if (option.legs2) {
                option.legs2 = JSON.parse(option.legs2);
              }
            });
            setFlightOptions(flightOptions)
          }
        });
    }

    if (eventBus) {
      eventBus.bind('GetBookingFlightOptions.open', open);
      return () => {
        eventBus.unbind('GetBookingFlightOptions.open', open);
      }
    }
  }, [eventBus]);


  const title = `Flight Options ${record ? `${record.charterOrigin} to ${record.destination}`: ``}`;
  const message = `${record ? flightOptions && Array.isArray(flightOptions) && flightOptions.length > 0 ? `Select the required flight option` : `Could not find any flight departing ${record.charterOrigin} en-route to ${record.destination}` : ``}`

  const getButtons = () => {
    return (
      {
        cancel:{icon: "cancel", key: "Close", label: "Close", color: "primary"}
      }
    );
  }

  const renderFlightOptions = () => {

    return(
      flightOptions.map(option => {
        let fullRouting = null;
        let fullDestinationRouting = null;
        if (Number(option.tripCount) > 1 || Number(option.legCount > 1)) {
          fullRouting = [{airport: option.originAirportCode, transportType: "PRIMARY"}];
          fullDestinationRouting = [`(Full Routing:  ${option.originAirportCode}`];
          option.legs1.forEach(leg => {
            fullRouting.push({airport: leg.destination, transportType: leg.transportType});
            fullDestinationRouting.push(leg.destination);
          });
          if (Number(option.tripCount) > 1) {
            option.legs2.forEach(leg => {
              fullRouting.push({airport: leg.destination, transportType: leg.transportType});
              fullDestinationRouting.push(leg.destination);
            });
          }
          // fullRouting[fullRouting.length - 1] = `${fullRouting[fullRouting.length - 1]})`;
          fullDestinationRouting[fullDestinationRouting.length - 1] = `${fullDestinationRouting[fullDestinationRouting.length - 1]})`;
        }
        return (
          <Fragment>
            <Grid item xs={12} checkChildren={true}>
              <LabelledPaper {...defaultLabelledPaperProps} label="" checkChildren={true}>
                <FormControl checkChildren={true} key={`FC-main-${option.trip1}`} style={{display: "block" }}>
                  <FormGroup checkChildren={true} key={`FG-main-${option.trip1}`} style={{padding: "6px 2px 2px 2px"}}>
                    <Button
                      style={{padding: 0}}
                      onClick={(event) => {
                        setDialogStates({showDialog: false});
                        setRecord(null);
                        setFlightOptions(null);
                        if (props.close) {
                          const selectedTrips = [option.trip1, option.trip2];
                          const selectedFlights = [[...option.legs1]];
                          const firstLeg = option.legs1[0];
                          const flightDate = moment.utc(option.scheduledDepartureTimeUTC).format('YYYY-MM-DD');
                          const departureFlight = `${option.airlineCode}-${option.flightNo} ${moment.utc(option.scheduledDepartureTimeUTC).format('DD MMM HH:mm')} ${option.originAirportCode}-${firstLeg.destination} ${fullDestinationRouting ? fullDestinationRouting.join("-") : ``}`;
                          if (option.legs2 && Array.isArray(option.legs2))
                            selectedFlights.push(option.legs2);
                          props.close(flightDate, departureFlight, selectedTrips, selectedFlights);
                        }
                      }}
                    >
                      <div style={{ padding: "10px 20px 10px 20px", textAlign: "center"}}>
                        <div style={{ padding: 0, paddingTop: 0, textAlign: "center"}}>
                          <AirportData
                            style={{fontSize: 12, padding: 0, paddingBottom: 2, width: "100%"}}
                            airportCode={option.originAirportCode}
                            field='airportName'
                          />
                          <div style={{fontSize: 12, transform: "rotate(180deg)"}}><Icon style={{fontSize: 10}}>flight</Icon></div>
                          <AirportData
                            style={{fontSize: 12, padding: 0, paddingTop: 2, width: "100%"}}
                            airportCode={option.destinationAirportCode}
                            field='airportName'
                          />
                          <FullRoute fullRoute={fullRouting} airport={option.originAirportCode}/>
                        </div>
                        <FlightBlock airportCode={option.originAirportCode} flightTime={option.scheduledDepartureTimeUTC} withinCurfew={false} />
                        <div style={{verticalAlign: "top", display: "inline-block"}}>
                          <div style={{fontSize:12, marginTop: 10, marginRight: 10, marginLeft: 10, fontWeight: 800}}>{option.airlineCode}-{option.flightNo}</div>
                          <div style={{transform: "rotate(90deg)", padding: "5px 15px"}}><Icon>flight</Icon></div>
                          <div style={{fontSize:10, marginTop: 5, marginRight: 10, marginLeft: 10, fontWeight: 600, color: "#909090"}}>{option.isFreesale1 ? "Free Sale" : "Allotment"}</div>
                        </div>
                        {option.tripCount > 1
                          ?
                          <Fragment>
                            <FlightBlock airportCode={option.transitAirport} flightTime={option.transitScheduledDepartureTimeUTC} withinCurfew={false} />
                            <div style={{verticalAlign: "top", display: "inline-block"}}>
                              <div style={{fontSize:12, marginTop: 10, marginRight: 10, marginLeft: 10, fontWeight: 800}}>{option.transitAirlineCode}-{option.transitFlightNo}</div>
                              <div style={{transform: "rotate(90deg)", padding: "5px 15px"}}><Icon>flight</Icon></div>
                              <div style={{fontSize:10, marginTop: 5, marginRight: 10, marginLeft: 10, fontWeight: 600, color: "#909090"}}>{option.isFreesale2 ? "Free Sale" : "Allotment"}</div>
                            </div>
                          </Fragment>
                          :
                          <></>
                        }
                        <FlightBlock airportCode={option.destinationAirportCode} flightTime={option.scheduledArrivalTimeUTC} withinCurfew={false} />
                      </div>
                    </Button>
                  </FormGroup>
                </FormControl>
              </LabelledPaper>
            </Grid>
          </Fragment>
        )
      }));
  }

  return (
    <div key="formContainer" style={{width: "100%", textAlign:"left" }}>
      {record
        ?
          <FormDialog
            key="Booking Flight Options"
            title={title}
            message={message}
            messageAboveScroll
            open={dialogStates.showDialog && flightOptions}
            dialogOptions={{maxWidth: "md", fullWidth: true, PaperProps: paperProps}}
            record={record}
            // validator={companyUserValidator}
            validatorPosition="top"
            alert={alert}
            formHeightOffset={320}
            titleBarStyle={{backgroundColor: '#3f3f3f', color: theme.palette.primary.main}}
            buttonBarStyleOverride={{
              position: "relative",
              width: "calc(100% - 15px)",
              backgroundColor: "#ffffff",
              borderTop: `1px solid ${props.fullPageStyle ? "grey" : "lightgrey"}`, ...props.fullPageStyle
            }}
            formBodyStyle={{...props.fullPageStyle}}
            style={{...props.fullPageStyle}}
            buttons={getButtons()}
            onChange={(state) => {
              if (state.buttonPressed === "cancel") {
                setDialogStates({showDialog: false});
                setRecord(null);
                setFlightOptions(null);
              }
              if (state.buttonPressed === "save") {

              } else {
              }
            }}
          >
            <Grid container checkChildren={true} spacing={3}>
              {flightOptions && Array.isArray(flightOptions) ? renderFlightOptions : <></>}
            </Grid>
          </FormDialog>
        :
          <></>
      }
    </div>
  )
}

export default FlightOptions;
